import React, { useContext, useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Context } from "../../index";
import { FaPlusSquare, FaThList } from "react-icons/fa";
import ListGroup from "react-bootstrap/ListGroup";
import { Badge, Button, Col, Row } from "react-bootstrap";
import {getPollItemsCurrentUser, getPoolsCurrentUser} from "../../http/poolAPI"; // Импорт метода API для получения опросов
import { useNavigate } from "react-router-dom";
import {PAY_ROUTE, POLL_LIBRARY_ROUTE} from "../../utils/consts";

const ColPollItems = observer(({ onPoolItemSelect, setActiveComponent, onClose }) => {
    const { poolStore } = useContext(Context);
    const { user, book } = useContext(Context);
    const [hoveredItemId, setHoveredItemId] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.user?.id) {
            getPollItemsCurrentUser(user.user.id)
                .then((data) => {
                    poolStore.setCurrentUserPoolItems(data);
                })
                .catch((err) => console.error("❌ Error:", err));
        }
    }, [user?.user?.id, poolStore]);

    const handleClick = (p) => {
        poolStore?.setSelectedPoolItem(p);
        onPoolItemSelect(p);
        if (onClose) {
            onClose();
        }
    };

    const viewAllPoolItems = () => {
        user?.setActiveComponent("AllPollItems")
        if (onClose) {
            onClose();
        }
    };

    const pollTypeLabels = {
        'COVER_POLL': 'Cover Poll',
        'TITLE_POLL': 'Title Poll',
        'COVER_TITLE_POLL': 'Cover & Title Poll',
        'DESCRIPTION_POLL': 'Description Poll',
        'MIXED_POLL': 'Mixed Poll',
    };

    const demoPollItems = [
        {
            id: 'demo-1',
            isDemo: true,
            respondent_step: 'STEP2',
            pool: {
                id: 'D101',
                pool_type: 'COVER_POLL',
                pool_item1_flag: true,
                pool_item2_flag: true,
            }
        },
        {
            id: 'demo-2',
            isDemo: true,
            respondent_step: 'STEP1',
            pool: {
                id: 'D102',
                pool_type: 'TITLE_POLL',
                pool_item1_flag: true,
                pool_item2_flag: true,
                pool_item3_flag: true,
            }
        },
        {
            id: 'demo-3',
            isDemo: true,
            respondent_step: 'STEP2',
            pool: {
                id: 'D103',
                pool_type: 'MIXED_POLL',
                pool_item1_flag: true,
                pool_item2_flag: true,
                pool_item3_flag: true,
                pool_item4_flag: true,
            }
        },
        {
            id: 'demo-4',
            isDemo: true,
            respondent_step: 'STEP1',
            pool: {
                id: 'D104',
                pool_type: 'DESCRIPTION_POLL',
                pool_item1_flag: true,
            }
        },
        {
            id: 'demo-5',
            isDemo: true,
            respondent_step: 'STEP2',
            pool: {
                id: 'D105',
                pool_type: 'COVER_TITLE_POLL',
                pool_item1_flag: true,
                pool_item2_flag: true,
            }
        }
    ];

    const isDemoMode = poolStore?.currentUserPoolItems?.length === 0;

    const pollItemsToDisplay = isDemoMode
        ? demoPollItems
        : poolStore.currentUserPoolItems.slice(0, 10);


    return (
        <div className="mt-2">
            <h5 style={{ marginBottom: '-16px' }} className="mx-auto p-2 text-muted">Polls You're Taking</h5>
            <div style={{ marginBottom: '5px', fontSize: 'small' }} className="mx-auto p-2 text-muted">
                {poolStore?.currentUserPoolItems?.length > 0
                    ? 'Last 10 polls you’ve taken:'
                    : 'Here are 5 demo polls. Once you take your first real poll, they’ll be replaced automatically.'}
            </div>

            <ListGroup key={poolStore?.currentUserPoolItems?.length} style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {pollItemsToDisplay.map(p => {
                    const isDemo = p.isDemo;

                    return (
                        <ListGroup.Item
                            key={p.id}
                            className={`list-group-item list-group-item-action small truncated-text shadow-sm ${
                                hoveredItemId === p.id || poolStore?.selectedPoolItem?.id === p.id ? 'list-group-item-success' : ''
                            }`}
                            style={{
                                cursor: isDemo ? 'not-allowed' : 'pointer',
                                opacity: isDemo ? 0.85 : 1,
                                borderRadius: '.25rem',
                                transition: 'transform .2s',
                                boxShadow: hoveredItemId === p.id || poolStore?.selectedPoolItem?.id === p.id
                                    ? '0px 4px 12px rgba(0, 0, 0, 0.1)'
                                    : 'none',
                                paddingTop: '0.20rem',
                                paddingBottom: '0.20rem',
                            }}
                            onMouseEnter={() => !isDemo && setHoveredItemId(p.id)}
                            onMouseLeave={() => !isDemo && setHoveredItemId(null)}
                            onClick={() => {
                                if (!isDemo) handleClick(p);
                            }}
                        >
                            <Col className="d-flex align-items-start">
                <span style={{
                    marginLeft: "15px",
                    marginRight: "0px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                    maxWidth: "105%"
                }}>
                    {pollTypeLabels[p.pool.pool_type] || 'Simple Poll'} #{p?.pool?.id}-{p?.id}, {
                    Array.from({ length: 8 }).filter((_, i) =>
                        p?.pool?.[`pool_item${i + 1}_flag`]
                    ).length || 0
                } Options
                </span>
                            </Col>

                            {p.respondent_step === 'STEP1' && (
                                <Badge bg="warning" pill className="position-absolute ms-3 text-dark top-50 start-0 translate-middle">
                                    R
                                </Badge>
                            )}
                            {p.respondent_step === 'STEP2' && (
                                <Badge
                                    bg="success"
                                    pill
                                    className="position-absolute ms-3 top-50 start-0 translate-middle p-0 d-flex align-items-center justify-content-center"
                                    style={{ width: '20px', height: '20px' }}
                                >
                                    <i className="bi bi-check fs-5"></i>
                                </Badge>
                            )}
                        </ListGroup.Item>
                    );
                })}

                <div className="mt-2">

                    <Row className="justify-content-center">
                        <Col xs="auto">

                            <Button
                                variant="outline-success"
                                className="m-1 shadow-sm btn-sm d-flex align-items-center"
                                onClick={viewAllPoolItems}
                            >
                                <FaThList className="me-2" />View all
                            </Button>



                        </Col>
                        <Col xs="auto">
                            <Button
                                variant="outline-success"
                                className="m-1 shadow-sm btn-sm d-flex align-items-center"
                                onClick={() => {
                                    book.setSelectedLanguage('');
                                    book.setSelectedGenre('');
                                    book.setSelectedPrice('');
                                    book.setSelectedAssType('');
                                    navigate(POLL_LIBRARY_ROUTE);
                                }}
                            >
                                <FaPlusSquare className="me-2" />Take Poll
                            </Button>
                        </Col>
                    </Row>
                </div>


            </ListGroup>
        </div>
    );
});

export default ColPollItems;
